var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.039 19.5q-3.142 0-5.32-2.18-2.18-2.178-2.18-5.318t2.18-5.321Q8.896 4.5 12.038 4.5q1.753 0 3.319.78a7.1 7.1 0 0 1 2.604 2.2V4.5h1.5v6.115h-6.116v-1.5h3.95a5.9 5.9 0 0 0-2.192-2.281A5.9 5.9 0 0 0 12.039 6q-2.5 0-4.25 1.75T6.039 12t1.75 4.25 4.25 1.75a5.86 5.86 0 0 0 3.475-1.1 5.8 5.8 0 0 0 2.175-2.9h1.58q-.68 2.448-2.681 3.974t-4.55 1.526"
  })));
};
export default SvgRefresh;